import { getAccessToken } from '@lib/msal';
import type { PersonDetail } from '@components/people/PersonDetailPanel';
import type { OrgDetail } from '@components/people/OrgDetailPanel';

/**
 * Fetch a person's full detail from the API.
 * Separated from the component file so react-refresh/only-export-components
 * lint rule is satisfied.
 */
export async function fetchPersonDetail(personId: number): Promise<PersonDetail> {
  const apiBase = (import.meta.env.VITE_API_URL || '').replace(/\/api\/?$/, '');
  const token = await getAccessToken();
  const response = await fetch(`${apiBase}/api/beacon/people/${personId}`, {
    headers: token ? { Authorization: `Bearer ${token}` } : {},
  });
  if (!response.ok) {
    throw new Error('Failed to load person details');
  }
  const data = await response.json();
  return data.data as PersonDetail;
}

/**
 * Fetch an organisation's full detail from the API.
 */
export async function fetchOrgDetail(orgId: number): Promise<OrgDetail> {
  const apiBase = (import.meta.env.VITE_API_URL || '').replace(/\/api\/?$/, '');
  const token = await getAccessToken();
  const response = await fetch(`${apiBase}/api/beacon/organisations/${orgId}`, {
    headers: token ? { Authorization: `Bearer ${token}` } : {},
  });
  if (!response.ok) {
    throw new Error('Failed to load organisation details');
  }
  const data = await response.json();
  return data.data as OrgDetail;
}
